"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Abstraction of Material UI's `CircularProgress`
 * 
 * Original author @heron-web/material (no longer maintained)
 */const Loader = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress.default, {
    classes: props.classes,
    className: props.className,
    color: props.color,
    disableShrink: props.variant === "indeterminate" ? true : undefined,
    size: props.size,
    thickness: props.thickness,
    value: props.value,
    variant: props.variant
  });
};
Loader.propTypes = {
  classes: _propTypes.default.object,
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(["primary", "secondary", "inherit"]),
  size: _propTypes.default.number,
  thickness: _propTypes.default.number,
  value: _propTypes.default.number,
  variant: _propTypes.default.oneOf(["indeterminate", "determinate"])
};
Loader.defaultProps = {
  color: "primary",
  variant: "indeterminate"
};
var _default = exports.default = Loader;